module.exports = __webpack_public_path__ + "static/img/xarlyey.ebb5b13.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/tabs/xarlyey.png
// module id = Hsru
// module chunks = 1